import { Mutation } from 'vuex';
import { IModuleState } from './types';

// 当前组织发起的申请列表
export const setMyApplications: Mutation<IModuleState> = (state, payload) => {
  state.applyList.data = payload.data;
  state.applyList.loading = !!payload.loading;
};

// 申请日志
export const setApplyLogs: Mutation<IModuleState> = (state, payload) => {
  state.applyLogs.data = payload.data;
  state.applyLogs.pageNum = payload.pageNum;
  state.applyLogs.pageSize = payload.pageSize;
  state.applyLogs.total = payload.total;
  state.applyLogs.loading = !!payload.loading;
};

// 等待我审核的申请列表
export const setMyAudits: Mutation<IModuleState> = (state, payload) => {
  state.auditList.data = payload.data;
  state.auditList.loading = !!payload.loading;
};

// 审核日志
export const setAuditLogs: Mutation<IModuleState> = (state, payload) => {
  state.auditLogs.data = payload.data;
  state.auditLogs.pageNum = payload.pageNum;
  state.auditLogs.pageSize = payload.pageSize;
  state.auditLogs.total = payload.total;
  state.auditLogs.loading = !!payload.loading;
};

// 所有私有品牌列表
export const setAllPrivateBrands: Mutation<IModuleState> = (state, payload) => {
  state.allPrivateBrands.data = payload.data;
  state.allPrivateBrands.loading = !!payload.loading;
};

// 确认弹窗
export const setConfirm: Mutation<IModuleState> = (state, payload) => {
  state.confirm.type = payload.type;
  state.confirm.title = payload.title;
  state.confirm.content = payload.content;
  state.confirm.data = payload.data || null;
  state.confirm.visible = !!payload.visible;
  state.confirm.loading = !!payload.loading;
};

export const setProcessing: Mutation<IModuleState> = (state, payload) => {
  state.processing = !!payload;
};

export const setLoading: Mutation<IModuleState> = (state, payload) => {
  state.loading = !!payload;
};
